'use es6';

// Left side of this object must match exactly the string that is in TinyMCE source
// Right side of this object maps to the translation key in the lang yaml file
export const lang = {
  Advanced: 'Advanced',
  Alignment: 'Alignment',
  Anchor: 'Anchor',
  Anchors: 'Anchors',
  Author: 'Author',
  'Background color': 'Background color',
  Blockquote: 'Blockquote',
  Blocks: 'Blocks',
  Body: 'Body',
  Bold: 'Bold',
  Border: 'Border',
  'Bullet list': 'Bullet list',
  Cancel: 'Cancel',
  Caption: 'Caption',
  Cell: 'Cell',
  'Cell padding': 'Cell padding',
  'Cell properties': 'Cell properties',
  'Cell spacing': 'Cell spacing',
  'Cell type': 'Cell type',
  Center: 'Center',
  Circle: 'Circle',
  'Clear formatting': 'Clear formatting',
  Close: 'Close',
  Code: 'Code',
  Cols: 'Cols',
  Column: 'Column',
  'Column group': 'Column group',
  'Constrain proportions': 'Constrain proportions',
  Copy: 'Copy',
  'Copy row': 'Copy row',
  'Could not find the specified string.': 'noStringMatch',
  Cut: 'Cut',
  'Cut row': 'Cut row',
  'Decrease indent': 'Decrease indent',
  Default: 'Default',
  'Delete column': 'Delete column',
  'Delete row': 'Delete row',
  'Delete table': 'Delete table',
  Description: 'Description',
  Dimensions: 'Dimensions',
  Disc: 'Disc',
  Div: 'Div',
  'Document properties': 'Document properties',
  Edit: 'Edit',
  Embed: 'Embed',
  Emoticons: 'Emoticons',
  Encoding: 'Encoding',
  File: 'File',
  Find: 'Find',
  'Find and replace': 'Find and replace',
  Finish: 'Finish',
  'Font Family': 'Font Family',
  'Font Sizes': 'Font Sizes',
  Footer: 'Footer',
  Format: 'Format',
  Formats: 'Formats',
  Fullscreen: 'Fullscreen',
  General: 'General',
  Header: 'Header',
  'Header cell': 'Header cell',
  Headers: 'Headers',
  Height: 'Height',
  'Horizontal line': 'Horizontal line',
  'Horizontal space': 'Horizontal space',
  Ignore: 'Ignore',
  'Ignore all': 'Ignore all',
  'Image description': 'Image description',
  'Increase indent': 'Increase indent',
  Inline: 'Inline',
  Insert: 'Insert',
  'Insert column after': 'Insert column after',
  'Insert column before': 'Insert column before',
  'Insert row after': 'Insert row after',
  'Insert row before': 'Insert row before',
  'Insert table': 'Insert table',
  'Insert template': 'Insert template',
  Keywords: 'Keywords',
  Left: 'Left',
  'Left to right': 'Left to right',
  'Match case': 'Match case',
  'Merge cells': 'Merge cells',
  Name: 'Name',
  'New document': 'New document',
  'New window': 'New window',
  Next: 'Next',
  'Nonbreaking space': 'Nonbreaking space',
  None: 'None',
  'Numbered list': 'Numbered list',
  OK: 'OK',
  Ok: 'Ok',
  'Page break': 'Page break',
  Paragraph: 'Paragraph',
  Paste: 'Paste',
  'Paste as text': 'Paste as text',
  'Paste row after': 'Paste row after',
  'Paste row before': 'Paste row before',
  'Paste your embed code below:': 'Paste your embed code below',
  Poster: 'Poster',
  Pre: 'Pre',
  Prev: 'Prev',
  Preview: 'Preview',
  Print: 'Print',
  Redo: 'Redo',
  Replace: 'Replace',
  'Replace all': 'Replace all',
  'Replace with': 'Replace with',
  Right: 'Right',
  'Right to left': 'Right to left',
  Robots: 'Robots',
  Row: 'Row',
  'Row group': 'Row group',
  'Row properties': 'Row properties',
  'Row type': 'Row type',
  Rows: 'Rows',
  Save: 'Save',
  Scope: 'Scope',
  'Select all': 'Select all',
  'Show blocks': 'Show blocks',
  'Show invisible characters': 'Show invisible characters',
  Source: 'Source',
  'Source code': 'Source code',
  'Special character': 'Special character',
  Spellcheck: 'Spellcheck',
  'Split cell': 'Split cell',
  Square: 'Square',
  Style: 'Style',
  Table: 'Table',
  'Table properties': 'Table properties',
  Target: 'Target',
  Templates: 'Templates',
  'Text color': 'Text color',
  'Text to display': 'Text to display',
  Title: 'Title',
  Tools: 'Tools',
  Underline: 'Underline',
  Undo: 'Undo',
  'Upper Alpha': 'Upper Alpha',
  'Upper Roman': 'Upper Roman',
  Url: 'Url',
  'Vertical space': 'Vertical space',
  View: 'View',
  'Visual aids': 'Visual aids',
  'Whole words': 'Whole words',
  Width: 'Width',
  'Words: {0}': 'Words: {0}'
};